import React from "react";
import { ConnectedRouter } from "connected-react-router";
import { Switch, Route } from "react-router";
import HomeContainer from "../components/Home";
import ScenarioView from "components/Scenarios";
import CentralArizonaView from "components/CentralArizona";
import WaterUser from "components/WaterUser";
import LoginContainer from "../components/Auth/Login";
import RegisterContainer from "../components/Auth/Register";
import LogoutContainer from "../components/Auth/Logout";
import ResetPassword from "../components/Auth/ResetPassword";
import UsersContainer from "../components/User";
import InvitesContainer from "components/Invites";
import SecurityContainer from "components/security";
import SettingsContainer from "components/settings";
import FeatureSettingsContainer from "components/FeatureSettings";
import { AppRouteURI } from "./RoleBasedAccess";
import NotFound from "../components/app/NotFound";
import RouteAuth from "./RouteAuth";
import Arizona from "components/Arizona";
import Technical from "components/TechnicalView";
import Public from "components/PublicView";
import useIsDevUrl from "hooks/useIsDevUrl";
import { VerifyEmail } from "components/Auth/VerifyEmail/VerifyEmail";
// import ResendVerification from "components/Auth/ResendVerification";

const AppRouter = ({ history }) => {
  const isDevUrl = useIsDevUrl();
  
  if (isDevUrl) {
    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route path={AppRouteURI.HOME} component={Technical} />
        </Switch>
      </ConnectedRouter>
    )
  }

  return (
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact path={AppRouteURI.HOME} component={HomeContainer} />
        <RouteAuth path={AppRouteURI.SCENARIO} component={ScenarioView} />
        <Route
          path={AppRouteURI.CENTRAL_ARIZONA}
          component={CentralArizonaView}
        />
        <Route path={AppRouteURI.PUBLIC} component={Public} />
        <RouteAuth path={AppRouteURI.VISUALIZATIONS} component={Technical} />
        <RouteAuth path={AppRouteURI.MAP_VIZ} component={Technical} />
        <RouteAuth path={AppRouteURI.HONEYCOMB_VIZ} component={Technical} />
        <RouteAuth path={AppRouteURI.PUBLIC_MAP_VIZ} component={Public} />
        <RouteAuth path={AppRouteURI.PUBLIC_HONEYCOMB_VIZ} component={Public} />
        <RouteAuth path={`${AppRouteURI.DOUGHNUT_VIZ}/:type/:dropdown`} component={Technical} />
        <RouteAuth path={AppRouteURI.AREA_VIZ} component={Technical} />
        <RouteAuth path={AppRouteURI.GUAGUE_VIZ} component={Technical} />
        <RouteAuth path={AppRouteURI.WATER_USER_VIZ} component={WaterUser} />
        <RouteAuth path={AppRouteURI.WATER_USER} component={WaterUser} />
        <Route path={AppRouteURI.ARIZONA} component={Arizona} />
        <Route path={AppRouteURI.LOGIN} component={LoginContainer} />
        <Route path={AppRouteURI.LOGOUT} component={LogoutContainer} />
        <Route path={AppRouteURI.REGISTER} component={RegisterContainer} />
        <Route path={AppRouteURI.VERIFY_EMAIL} component={VerifyEmail} />
        <Route path={AppRouteURI.INVITATION} component={RegisterContainer} />
        <RouteAuth path={AppRouteURI.MEMBERS} component={UsersContainer} />
        <RouteAuth path={AppRouteURI.SECURITY} component={SecurityContainer} />
        <RouteAuth path={AppRouteURI.SETTINGS} component={SettingsContainer} />
        <RouteAuth path={AppRouteURI.FEATURE_SETTINGS} component={FeatureSettingsContainer} />
        <RouteAuth path={AppRouteURI.INVITES} component={InvitesContainer} />
        <Route path={AppRouteURI.RESET_PWD} component={ResetPassword} />
        <Route component={NotFound} />
      </Switch>
    </ConnectedRouter>
  );
};

export default AppRouter;
